/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function NubGhost(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'NubGhost',
      'aria-hidden': true,
      focusable: false,
      width:  24 * scale,
      height: 24 * scale,
      viewBox: '0 0 24 24',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('defs', null,createElement('path', {"d":"M15.507 19a7 7 0 0 0 0-14C9.382 5 2 12 2 12s7.382 7 13.507 7","id":"wf-svg-NubGhost-__a"}),createElement('mask', {"id":"wf-svg-NubGhost-__b","x":"0","y":"0","width":"20.507","height":"14","fill":"#fff"},createElement('use', {"xlinkHref":"#wf-svg-NubGhost-__a"}))),createElement('use', {"mask":"url(#wf-svg-NubGhost-__b)","transform":"rotate(-180 12.254 12)","xlinkHref":"#wf-svg-NubGhost-__a","stroke":"#1a1a1a","fill":"#e89153","fillRule":"evenodd"}))
}
